import PrintMChat from "./printMChat.vue";
export default PrintMChat;
